const filters = [
  {
    id: 1,
    title: "Jeg har venstrehånd",
  },
  {
    id: 2,
    title: "Jeg har høyrehånd",
  },
  {
    id: 3,
    title: "Jeg har to hender",
  },
  {
    id: 4,
    title: "Jeg har bukse med lommer",
  },
  {
    id: 5,
    title: "Jeg har sekk/veske",
  },
  {
    id: 6,
    title: "Jeg har jakke med lommer",
  },
  {
    id: 50,
    title: "Jeg synes det er flaut å gå med tomflaske",
  },
  {
    id: 60,
    title: "Jeg synes det er flaut å ha sokker i sandalene",
  },
  {
    id: 7,
    title: "Jeg har en sykkel",
  },
  {
    id: 20,
    title: "Jeg er på fjellet",
  },
  {
    id: 21,
    title: "Jeg er i skogen",
  },
  {
    id: 22,
    title: "Jeg er ved sjøen",
  },
  {
    id: 23,
    title: "Jeg er i et fotostudio",
  },
  {
    id: 30,
    title: "Jeg er jente",
  },
  {
    id: 31,
    title: "Jeg er gutt",
  },
  {
    id: 32,
    title: "Jeg er ikke-binær",
  },
];
export default filters;
